$(function() {
    // 初期化
    var SearchTab = {
      // 検索フォームの初期値
      default_search_type: "keyword",
      set_search_type: function(type){
        $('#search_type').html(type);
      },
      get_search_type: function(){
        return $('#search_type').html();
      },
      // 検索フォームの種類
      search_types: function(){
        return new Array("keyword", "order");
      },
      initialize_search_type: function(){
        if (this.get_search_type() == "") {
          this.set_search_type(this.default_search_type);
          return this.default_search_type;
        }else{
          return this.get_search_type();
        }
      },
      hide_search_detail: function(){
        $('#search .detail').hide();
      },
      search_load: function(){
        return $('#product_content #search_load');
      },
      hide_search_load: function(){
        this.search_load().hide();
      },
      show_search_load: function(){
        this.search_load().show();
      },
      initialize: function(){
        jQuery.each(this.search_types(), function(i, type){
          if (type != SearchTab.initialize_search_type()){
            $('.search_tab.' + type).hide();
          }
        });
        $('#search_type').hide();
        this.hide_search_detail();
        this.hide_search_load();
        $("#search > .tab > li#button_" + this.get_search_type()).addClass("active");
      }
    };
    SearchTab.initialize();
    // 詳細検索項目表示のトグル
    $('#search .control a').click(function(){
      $('#search .detail').slideToggle('fast');
      $("#search .search_tab." + SearchTab.get_search_type()).find(".control a span").toggle();
    });
    // 検索タブ切り替え
    $("#search > .tab > li").click(function(){
      //切り替え元タブを閉じるに設定
      $("#search .search_tab." + SearchTab.get_search_type()).find(".control a span:eq(0)").css("display", "none");
      $("#search .search_tab." + SearchTab.get_search_type()).find(".control a span:eq(1)").css("display", "inline");

      $(this).addClass("active");
      var change_tab_name = $(this).attr("id").replace(/^button_/,"");
      // 選択された検索フォーム以外の要素を隠す
      jQuery.each(SearchTab.search_types(), function(i, type){
        if (type != change_tab_name) {
          $("#search > .tab > li#button_" + type).removeClass("active");
          $('.search_tab.' + type).hide();
        }
      });
      SearchTab.hide_search_detail();
      SearchTab.set_search_type(change_tab_name);
      $('.search_tab.' + change_tab_name).show();
    });

    // autopager settings
    if ($('#activate_auto_pagerize').length > 0) {

		var default_page_number = $('#activate_auto_pagerize').data('last-show-page');

    	var window = this, options = {},
    		content, currentUrl, nextUrl,
    		active = false,
    		defaults = {
    			autoLoad: true,
    			page: default_page_number,
    			content: '.content',
    			link: 'a[rel=next]',
    			insertBefore: null,
    			appendTo: null,
    			start: function() {},
    			load: function() {},
    			disabled: false
    		};

    	$.autopager = function(_options) {
    		var autopager = this.autopager;

    		if (typeof _options === 'string' && $.isFunction(autopager[_options])) {
    			var args = Array.prototype.slice.call(arguments, 1),
    				value = autopager[_options].apply(autopager, args);

    			return value === autopager || value === undefined ? this : value;
    		}

    		_options = $.extend({}, defaults, _options);
    		autopager.option(_options);

    		content = $(_options.content).filter(':last');
    		if (content.length) {
    			if (!_options.insertBefore && !_options.appendTo) {
    				var insertBefore = content.next();
    				if (insertBefore.length) {
    					set('insertBefore', insertBefore);
    				} else {
    					set('appendTo', content.parent());
    				}
    			}
    		}

    		setUrl();

    		return this;
    	};

    	$.extend($.autopager, {
    		option: function(key, value) {
    			var _options = key;

    			if (typeof key === "string") {
    				if (value === undefined) {
    					return options[key];
    				}
    				_options = {};
    				_options[key] = value;
    			}

    			$.each(_options, function(key, value) {
    				set(key, value);
    			});
    			return this;
    		},

    		enable: function() {
    			set('disabled', false);
    			return this;
    		},

    		disable: function() {
    			set('disabled', true);
    			return this;
    		},

    		destroy: function() {
    			this.autoLoad(false);
    			options = {};
    			content = currentUrl = nextUrl = undefined;
    			return this;
    		},

    		autoLoad: function(value) {
    			return this.option('autoLoad', value);
    		},

    		load: function() {
    			if (active || !nextUrl || options.disabled) {
    				return;
    			}

    			active = true;
    			options.start(currentHash(), nextHash());
        //   $.get(nextUrl, insertContent);
				$.get(nextUrl, insertContent)
					.done(
						function(data, textStatus, jqXHR){
							var url = new URL(window.location.href);
							var params = url.searchParams;
							if (params.get('last_show_page')){
								params.set('last_show_page', options.page);
							} else {
								params.append('last_show_page', options.page);
							}

							history.replaceState({}, null, url );
				  		}
					);

    			return this;
    		}

    	});

    	function set(key, value) {
    		switch (key) {
    			case 'autoLoad':
    				if (value && !options.autoLoad) {
    					$(window).scroll(loadOnScroll);
    				} else if (!value && options.autoLoad) {
    					$(window).unbind('scroll', loadOnScroll);
    				}
    				break;
    			case 'insertBefore':
    				if (value) {
    					options.appendTo = null;
    				}
    				break
    			case 'appendTo':
    				if (value) {
    					options.insertBefore = null;
    				}
    				break
    		}
    		options[key] = value;
    	}

    	function setUrl(context) {
    		currentUrl = nextUrl || window.location.href;
    		nextUrl = $(options.link, context).attr('href');
    	}

    	function loadOnScroll() {
    		if (content.offset().top + content.height() < $(document).scrollTop() + document.documentElement.clientHeight) {
    			$.autopager.load();
    		}
    	}

    	function insertContent(res) {
    		var _options = options,
    			nextPage = $('<div/>').append(res.replace(/<script(.|\s)*?\/script>/g, "")),
    			nextContent = nextPage.find(_options.content);

    		set('page', _options.page + 1);
    		setUrl(nextPage);
    		if (nextContent.length) {
    			if (_options.insertBefore) {
    				nextContent.insertBefore(_options.insertBefore);
    			} else {
    				nextContent.appendTo(_options.appendTo);
    			}
    			_options.load.call(nextContent.get(), currentHash(), nextHash());
    			content = nextContent.filter(':last');
    		}
    		active = false;
    	}

    	function currentHash() {
    		return {
    			page: options.page,
    			url: currentUrl
    		};
    	}

    	function nextHash() {
    		return {
    			page: options.page + 1,
    			url: nextUrl
    		};
    	}

      $.autopager({
        content: '.autopage',
        start: function(current, next){
          SearchTab.show_search_load();
        },
        load: function(current, next){
          SearchTab.hide_search_load();
        }
      });
    }
// 「全選択」する
// $('#multiple_categories_all').on('click', function() {
//   $(".multiple_categories_check_box").prop('checked', this.checked);
// });
// 「全選択」以外のチェックボックスがクリックされたら、
$(".multiple_categories_check_box").on('click', function() {
  var check_cnt = 0;
  $(".multiple_categories_check_box").each(function() {
    if ($(this).prop('checked') == true) {
      check_cnt += 1;
    }
  });
//   if ($('.multiple_categories_check_box').length == check_cnt) {
//     // 全てのチェックボックスにチェックが入っていたら
//     $('#multiple_categories_all').prop('checked', true);
//   } else {
//     // 1つでもチェックが入っていなかったら
//     $('#multiple_categories_all').prop('checked', false);
//   }
});
$(".btn_category_search").on('click', function() {
  // 要素を取得
  var title_code = $(this).attr('data-bs-code');
  var title_name = $(this).attr('data-bs-title');
  var category_id = $(this).attr('data-bs-id');
  var category_children = $(this).children('.child_category');
  // 絞り込みのカテゴリのチェック処理
  if (title_code == "01100") {
    // BestPrice
    // $('#multiple_categories_all').prop('checked', false);
    $('#multiple_categories_0').prop('checked', true);
    $('#multiple_categories_1').prop('checked', true);
    $('#multiple_categories_2').prop('checked', false);
  } else if (title_code == "01200") {
    // 数量割引
    // $('#multiple_categories_all').prop('checked', false);
    $('#multiple_categories_0').prop('checked', false);
    $('#multiple_categories_1').prop('checked', false);
    $('#multiple_categories_2').prop('checked', true);
  }
  else {
    // 上記以外
    // 全選択
    // $('#multiple_categories_all').prop('checked', true);
    $('.multiple_categories_check_box').prop('checked', false);
  }
  var category_child_links = "";
  //　子カテゴリからリンクを構築
  category_children.each(function() {
    category_child_links += "<button type='submit' name='category_id' value='" + $(this).attr('data-bs-id') + "' class='list-group-item list-group-item-action pt-4 pb-4 fs-18px'>" + $(this).attr('data-bs-name') + "<span class='icon-right02 position-absolute top-50 start-100 translate-middle'></span></button>"
  });
  category_child_links += "<button type='submit' name='category_id' value='" + category_id + "' class='list-group-item list-group-item-action pt-4 pb-4 fs-18px'>" + title_name + "全て<span class='icon-right02 position-absolute top-50 start-100 translate-middle'></span></button>"
  // 要素をセット
  $("#category_search_modal_title_label").attr('class','col-3 modal-title product_category category_' + title_code);
  $("#category_search_modal_title_text").html(title_name);
  $("#parent_category_modal").attr("value", category_id);
  $("#category_child_list").html(category_child_links);
  });
});
